import api from "../../../api/index";

export const selectDefaultProject = (token) => {
  if (token) {
    return api.get("authentication/jwt/user/get", {  headers: {
      Authorization:token.token 
    } });
  } else {
    return api.get("authentication/jwt/user/get");
  }
};

export const updateProject = (data) => {
  return api.post("authentication/jwt/user/update", data);
};
